import Home from "./Compontent/Home/Home";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from "./Compontent/Login";
import SelectClass from "./Compontent/Home/SelectClass";
import SelectSubject from "./Compontent/Home/SelectSubject";
import SubjectDetails from "./Compontent/Home/SubjectDetails";
import SubjectType from "./Compontent/Home/SubjectType";
import TeacherLogin from "./Compontent/Home/Mobile/TeacherLogin";
import Tlogin from "./Compontent/Home/Mobile/Tlogin";
import MobileSelectclass from "./Compontent/Home/Mobile/MobileSelectclass";
import MobileSelectSubject from "./Compontent/Home/Mobile/MobileSelectSubject";
import MobileSubjectDetails from "./Compontent/Home/Mobile/MobileSubjectDetails";
import MobileSubjectType from "./Compontent/Home/Mobile/MobileSubjectType";
import mobileselectsubjecttype from "./Compontent/Home/Mobile/mobileselectsubjecttype";
import HomeBranch from "./Compontent/Branch/HomeBranch";
import Signup from "./Compontent/Signup";
import Tsignup from "./Compontent/Home/Mobile/Tsignup";
import ChapterwiseDetails from "./Compontent/Home/ChapterwiseDetails";

function App() {

  return (
    <>
      <Router>
        <Routes>
          <Route path='*' />
          {/* <Route exact path="/" element={<Home />} /> */}
          <Route exact path="/branch/:branch_url/:url" element={<HomeBranch />} />
          <Route path="/branch/:branch_url/:url/login" element={<Login />} />
          <Route path="/branch/:branch_url/:url/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/branch/:branch_url/:url/teacher" element={<TeacherLogin />} />
          <Route path="/branch/:branch_url/:url/all-login" element={<Tlogin />} />
          <Route path="/branch/:branch_url/:url/all-signup" element={<Tsignup />} />
          <Route path="/branch/:branch_url/:url/mobile-select-class" element={<MobileSelectclass />} />
          {/* <Route path="/branch/:branch_url/:url/:class_id/:select_subject/" element={<MobileSubjectType />} /> */}
          <Route path="/branch/:branch_url/:url/:class_id/mobile-select-subject" element={<MobileSelectSubject />} />
          <Route path="/branch/:branch_url/:url/:class_id/:select_subject/mobile-chapterwise" element={<MobileSubjectDetails />} />
          <Route path="/branch/:branch_url/:url/:class_id/subject/:mobile_subject_url" element={<MobileSubjectType />} />
          <Route path="/branch/:branch_url/:url/select-class" element={<SelectClass />} />
          {/* <Route path="/select-subject" element={<SelectSubject />} /> */}
          <Route path="/branch/:branch_url/:url/:class_id/:select_subject/" element={<SelectSubject />} />
          <Route path="/subject-English" element={<SubjectDetails />} />
          <Route path="/branch/:branch_url/:url/subject/:subject_url" element={<SubjectType />} />
          <Route path="/branch/:branch_url/:url/:class_id/:select_subject/chapterwise" element={<SubjectDetails />} />
          <Route path="/branch/:branch_url/:url/:class_id/:select_subject/chapterwise/Videos" element={<ChapterwiseDetails />} />
        </Routes>
      </Router>
    </>

  );
}

export default App;
